<template>
  <div class="d-grid gap-3">
    <hr-full-width />

    <div v-if="decisionMaker" class="d-flex flex-column flex-lg-row align-items-start gap-3">
      <h3 class="flex-shrink-0 my-0">
        {{ i18n.t('petitions.view.write_to_target_fields.writing_to') }}
      </h3>
      <div class="flex-grow-1">
        <div>{{ decisionMaker.name }}</div>
        <div class="small-text">
          {{ decisionMaker.context }}
        </div>
      </div>
    </div>

    <text-input :label="i18n.t('activerecord.attributes.message_to_target.subject')" :value="subject"
                required :readonly="subjectLocked" input-id="message-to-target-subject"
                :validation-errors="validationErrors.subject" @changed="updateSubject" />
    <div>
      <write-to-target-tips :tips-html="instructionsHtml" />
      <text-input :label="i18n.t('activerecord.attributes.message_to_target.text')" :value="text" required
                  multiline :rows="8" input-id="message-to-target-text" :validation-errors="validationErrors.text"
                  @changed="updateText" />
    </div>
  </div>
</template>

<script>
import HrFullWidth from '../../campaign-action-shared/hr-full-width'
import TextInput from '@/components/inputs/text-input'
import WriteToTargetTips from '../write-to-target-tips'

export default {
  components: { HrFullWidth, TextInput, WriteToTargetTips },

  props: {
    decisionMaker: {
      type: Object,
      required: false
    },

    instructionsHtml: {
      type: String,
      required: true
    },

    subjectLocked: {
      type: Boolean,
      required: false,
      default: false
    },

    validationErrors: {
      type: Object,
      required: false,
      default: () => ({})
    },

    value: {
      type: Object,
      required: true
    }
  },

  emits: ['changed'],

  data() {
    return {
      subject: this.value.subject,
      text: this.value.text
    }
  },

  methods: {
    emitChanged() {
      this.$emit('changed', {subject: this.subject, text: this.text})
    },

    updateSubject(newValue) {
      this.subject = newValue
      this.emitChanged()
    },

    updateText(newValue) {
      this.text = newValue
      this.emitChanged()
    }
  }
}
</script>
